import { IMAGE_TYPES } from './constants';

export const IMAGE_TYPES_DATA = {
  [IMAGE_TYPES.DEFAULT]: {
    id: IMAGE_TYPES.DEFAULT,
    name: 'Обычный',
  },
};

export const IMAGE_TYPES_DATA_LIST = Object.values(IMAGE_TYPES_DATA);

export default {
  IMAGE_TYPES_DATA,

  IMAGE_TYPES_DATA_LIST,
};
